import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, Box } from '@mui/material';
import { Language } from '@mui/icons-material';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleChange = (event: any) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Language fontSize="small" />
      <Select
        value={i18n.language}
        onChange={handleChange}
        size="small"
        variant="outlined"
        sx={{ minWidth: 120 }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;